module.exports = __webpack_public_path__ + "img/40_69_005_920.4d5c2c45.jpg";